import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from './plugins/http/axios.js';
import pipes from './shared/pipes/pipes';
import directives from './shared/directives/directives';
import VueSweetalert2 from 'vue-sweetalert2';
import '@babel/polyfill';
import './assets/styles.css';

Vue.config.productionTip = false
Vue.use(VueSweetalert2);
new Vue({
    router,
    store,
    vuetify,
    axios,
    pipes,
    directives,
    render: h => h(App)
}).$mount('#app')